module.exports = __webpack_public_path__ + "img/popAr.ee31fa95.png";